import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { seoExtDomainDetailLoad } from "store/models/seoExtDomain";
import { DetailLoadComponent } from 'components/common';


const SeoExtDomainValue = (props) => {
  return (
    <DetailLoadComponent
      apiLoad={seoExtDomainDetailLoad}
      {...props}
      getDetailUrl={(id, item) => props.model.urls.detail(id)}
      render={({ id, item, linkPath }) => {
        const value = (item && item.domain) || id;

        return (
          <Fragment>
            {props.asLink && linkPath ?
              <Link to={linkPath}>{value}</Link> :
              <span>{value}</span>}
          </Fragment>
        );
      }}
    />
  );
};

const mapState = state => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.seoExtDomain,
});

export default connect(mapState)(SeoExtDomainValue);
